import { Input, Space } from 'antd';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { ReloadButton } from '@lib/common';
import { styleVariables } from '@lib/common';
import { CombinedFilterDropdown } from './combined-filter-dropdown.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSearchWithReloadComponent = styled.div.withConfig({
  displayName: "search-with-reloadcomponent__StyledSearchWithReloadComponent",
  componentId: "sc-tk0xxy-0"
})(["display:flex;gap:12px;"]);
var StyledSearch = styled.div.withConfig({
  displayName: "search-with-reloadcomponent__StyledSearch",
  componentId: "sc-tk0xxy-1"
})(["font-size:16px;flex:1;.ant-input-affix-wrapper{height:50px;border-radius:12px;border:1px solid ", ";padding:0 16px;transition:all 0.2s;box-shadow:0 1px 2px rgba(0,0,0,0.03);&:hover{border-color:", ";}&-focused{border-color:", " !important;box-shadow:0 0 0 2px rgba(26,90,255,0.1) !important;}.ant-input-prefix{margin-right:12px;color:", ";font-size:18px;}input{font-size:14px;color:", ";&::placeholder{color:", ";}}}"], styleVariables.colors.grey14, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.gray10, styleVariables.colors.grey100, styleVariables.colors.gray10);
var StyledActiveFilters = styled.div.withConfig({
  displayName: "search-with-reloadcomponent__StyledActiveFilters",
  componentId: "sc-tk0xxy-2"
})(["display:flex;align-items:center;gap:12px;margin-top:12px;padding-left:4px;"]);
var ActiveLabel = styled.span.withConfig({
  displayName: "search-with-reloadcomponent__ActiveLabel",
  componentId: "sc-tk0xxy-3"
})(["color:", ";font-size:14px;font-weight:500;"], styleVariables.colors.grey70);
var StyledFilterTag = styled.div.withConfig({
  displayName: "search-with-reloadcomponent__StyledFilterTag",
  componentId: "sc-tk0xxy-4"
})(["display:inline-flex;align-items:center;gap:6px;padding:6px 12px;background:", ";border:1.5px solid ", ";border-radius:20px;color:", ";font-size:14px;font-weight:600;transition:all 0.2s;.close-icon{display:flex;align-items:center;cursor:pointer;color:", ";font-size:12px;&:hover{color:", ";}}&:hover{border-color:", ";background:", ";}"], styleVariables.colors.gray1, styleVariables.colors.blue1, styleVariables.colors.grey100, styleVariables.colors.grey70, styleVariables.colors.red3, styleVariables.colors.blue3, styleVariables.colors.blue1); // No longer need StyledInputComponent if we use StyledSearch to style the affix wrapper

export var SearchWithReloadComponent = function SearchWithReloadComponent(_ref) {
  var handleSearch = _ref.handleSearch,
      isLoadingList = _ref.isLoadingList,
      handleReload = _ref.handleReload,
      searchReloadLabel = _ref.searchReloadLabel,
      typeOptions = _ref.typeOptions,
      statusOptions = _ref.statusOptions,
      selectedTypes = _ref.selectedTypes,
      selectedStatuses = _ref.selectedStatuses,
      onTypeChange = _ref.onTypeChange,
      onStatusChange = _ref.onStatusChange,
      filterLabels = _ref.filterLabels,
      searchValue = _ref.searchValue,
      onSearchChange = _ref.onSearchChange,
      handleClearFilter = _ref.handleClearFilter;

  var _useState = useState(searchValue || ''),
      localSearchValue = _useState[0],
      setLocalSearchValue = _useState[1];

  useEffect(function () {
    setLocalSearchValue(searchValue || '');
  }, [searchValue]);

  var handleSearchInputChange = function handleSearchInputChange(e) {
    var value = e.target.value;
    setLocalSearchValue(value);
    handleSearch(value); // Note: We don't call onSearchChange here to avoid immediate API calls if it's used for query state
  };

  var removeType = function removeType(id) {
    if (onTypeChange && selectedTypes) {
      onTypeChange(selectedTypes.filter(function (t) {
        return t !== id;
      }));
    }
  };

  var removeStatus = function removeStatus(id) {
    if (onStatusChange && selectedStatuses) {
      onStatusChange(selectedStatuses.filter(function (s) {
        return s !== id;
      }));
    }
  };

  var activeTypes = typeOptions === null || typeOptions === void 0 ? void 0 : typeOptions.filter(function (o) {
    return selectedTypes === null || selectedTypes === void 0 ? void 0 : selectedTypes.includes(o.id);
  });
  var activeStatuses = statusOptions === null || statusOptions === void 0 ? void 0 : statusOptions.filter(function (o) {
    return selectedStatuses === null || selectedStatuses === void 0 ? void 0 : selectedStatuses.includes(o.id);
  });
  var hasFilters = ((activeTypes === null || activeTypes === void 0 ? void 0 : activeTypes.length) || 0) > 0 || ((activeStatuses === null || activeStatuses === void 0 ? void 0 : activeStatuses.length) || 0) > 0;
  return /*#__PURE__*/_jsxs("div", {
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsxs(StyledSearchWithReloadComponent, {
      children: [/*#__PURE__*/_jsx(StyledSearch, {
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: searchReloadLabel.placeholder,
          value: localSearchValue,
          onChange: handleSearchInputChange,
          prefix: /*#__PURE__*/_jsx(SearchOutlined, {}),
          allowClear: true
        })
      }), typeOptions && statusOptions && filterLabels && /*#__PURE__*/_jsx(CombinedFilterDropdown, {
        typeOptions: typeOptions,
        statusOptions: statusOptions,
        selectedTypes: selectedTypes || [],
        selectedStatuses: selectedStatuses || [],
        onTypeChange: onTypeChange || function () {},
        onStatusChange: onStatusChange || function () {},
        onClearAll: handleClearFilter,
        labels: filterLabels
      }), /*#__PURE__*/_jsx(ReloadButton, {
        height: 50,
        width: 50,
        loading: isLoadingList,
        handleReload: handleReload,
        style: {
          borderRadius: '12px'
        }
      })]
    }), hasFilters && /*#__PURE__*/_jsxs(StyledActiveFilters, {
      children: [/*#__PURE__*/_jsx(ActiveLabel, {
        children: "Active:"
      }), /*#__PURE__*/_jsxs(Space, {
        size: 12,
        wrap: true,
        children: [activeTypes && activeTypes.length > 0 && /*#__PURE__*/_jsxs(StyledFilterTag, {
          children: ["Type: ", activeTypes.map(function (t) {
            return t.label;
          }).join(', '), /*#__PURE__*/_jsx("span", {
            className: "close-icon",
            onClick: function onClick() {
              return onTypeChange && onTypeChange([]);
            },
            children: /*#__PURE__*/_jsx(CloseOutlined, {})
          })]
        }), activeStatuses && activeStatuses.length > 0 && /*#__PURE__*/_jsxs(StyledFilterTag, {
          children: ["Status: ", activeStatuses.map(function (s) {
            return s.label;
          }).join(', '), /*#__PURE__*/_jsx("span", {
            className: "close-icon",
            onClick: function onClick() {
              return onStatusChange && onStatusChange([]);
            },
            children: /*#__PURE__*/_jsx(CloseOutlined, {})
          })]
        })]
      })]
    })]
  });
};